import React, { Suspense, lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';
import PrivateRoute from '../../utils/PrivateRoute/PrivateRoute';
import { DietDataProvider } from './core/providers/DietDataProvider';
import Loader from '../../common/Loader/Loader';
import { DIET_ROUTES, DIET_ROUTE_CONFIG } from './core/constants/routes';

const RecipeListPage = lazy(() => import('./workflow/recipe/list/RecipeListPage'));
const RecipeDetailPage = lazy(() => import('./workflow/recipe/view/RecipeDetailPage'));
const ReferenceDataPage = lazy(() => import('./workflow/utils/ReferenceDataPage'));
const TemplateListPage = lazy(() => import('./workflow/template/list/TemplateListPage'));
const TemplateCreatePage = lazy(() =>
  import('./workflow/template/modify/TemplateCreatePage')
);
const TemplateEditPage = lazy(() => import('./workflow/template/modify/TemplateEditPage'));
const AssignDietPlanPage = lazy(() =>
  import('./workflow/plan/modify/AssignDietPlanPage')
);

function DietShell({ element: Page, isPrivate = true }) {
  const inner = isPrivate ? <PrivateRoute element={Page} /> : <Page />;
  return (
    <Suspense fallback={<Loader />}>
      <DietDataProvider>{inner}</DietDataProvider>
    </Suspense>
  );
}

const PAGE_BY_PATH = {
  [DIET_ROUTES.RECIPES_LIST]: RecipeListPage,
  [DIET_ROUTES.RECIPES_NEW]: RecipeDetailPage,
  [DIET_ROUTES.RECIPES_DETAIL]: RecipeDetailPage,
  [DIET_ROUTES.DIET_REFERENCE_DATA]: ReferenceDataPage,
  [DIET_ROUTES.TEMPLATES_LIST]: TemplateListPage,
  [DIET_ROUTES.TEMPLATES_NEW]: TemplateCreatePage,
  [DIET_ROUTES.TEMPLATES_DETAIL]: TemplateEditPage,
  [DIET_ROUTES.PLANS_EDITOR]: AssignDietPlanPage,
};

/** Pre-built Route elements for use inside App Routes. */
export const dietRouteElements = (
  <>
    {DIET_ROUTE_CONFIG.map(({ path, isPrivate }) => (
      <Route
        key={path}
        path={path}
        element={<DietShell element={PAGE_BY_PATH[path]} isPrivate={isPrivate} />}
      />
    ))}
    <Route
      path="/recipe/detail"
      element={<Navigate to={DIET_ROUTES.RECIPES_LIST} replace />}
    />
  </>
);
